// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B4NT","questions":"styles_questions__3Rlv6","footer":"styles_footer__2WtBr"};